import React from "react";
import './style.css';
import Slide from "@material-ui/core/Slide";
import filterImage from "../../../images/filterImg.png";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { Button, Chip, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import {
  getEinvoiceData,
  setReceipientGstinFilter,
  setSelectedFromDate,
  setSelectedToDate,
  setSupplierGstinFilter,
} from "./action";
import { useEffect } from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const EinvFilter = ({
  openFilter,
  setOpenFilter,
  handleChipDelete,
  defaultPropsSupplierGstins,
  supplierGstin,
  onChangeSupplierGstin,
  handleAddSupplierGstin,
  defaultPropsReceipientGstins,
  receipientGstin,
  onChangeReceipientGstin,
  handleAddReceipientGstin,
  pageNumber,
  setPageNumber
}) => {
  const {
    supplierGstinFilter,
    receipientGstinFilter,
    selectedFromDate,
    selectedToDate,
    searchStr,
    checkedCancel,
    checkedIrn,
    checkedIrnNotGen,
    buyerGstinList
  } = useSelector((state) => state.EinvReducerNew);
  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      // Prevent closing the dialog on backdrop click or Escape key press
      return;
    }
    setOpenFilter(false);
  };

  const handleClearFilter = async () => {
    try {
      await dispatch(
        getEinvoiceData(
          searchStr,
          pageNumber,
          checkedIrn === true
            ? 1
            : checkedCancel === true
            ? 2
            : checkedIrnNotGen === true
            ? 3
            : "",
          [],
          [],
          "",
          ""
        )
      );
      dispatch(setSupplierGstinFilter([]));
      dispatch(setReceipientGstinFilter([]));
      dispatch(setSelectedFromDate(""));
      dispatch(setSelectedToDate(""));
      handleClose();
      // console.log("handleClearFilter called");
    } catch (error) {
      console.log(`Error in handleClearFilter: ${error}`);
    }
  };

  const handleFilterApply = async () => {
    try {
      await dispatch(
        getEinvoiceData(
          searchStr,
          1,
          checkedIrn === true
            ? 1
            : checkedCancel === true
            ? 2
            : checkedIrnNotGen === true
            ? 3
            : "",
          supplierGstinFilter,
          receipientGstinFilter,
          selectedFromDate,
          selectedToDate
        )
      );
      setPageNumber(1);
      setOpenFilter(false);
      // console.log("handleFilterApply called");
    } catch (error) {
      console.log(`Error in handleFilterApply: ${error}`);
    }
  };

  const isButtonDisabled =
    supplierGstinFilter?.length === 0 &&
    receipientGstinFilter?.length === 0 &&
    (!selectedFromDate || !selectedToDate);

  useEffect(() => {
    return () => handleClearFilter();
  }, []);

  return (
    <Dialog
      className="filterModal"
      open={openFilter}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth="sm"
    >
      <div
        style={{
          position: "absolute",
          top: "6px",
          left: "-26px",
          cursor: "pointer",
        }}
        // onClick={handleClose}
      >
        <img src={filterImage} alt="fliter" width="100px" height="40px" />
        <span
          style={{
            position: "absolute",
            top: "8px",
            left: "36px",
            fontSize: "12px",
            color: "white",
          }}
        >
          Filters
        </span>
      </div>
      <DialogTitle
        id="alert-dialog-slide-title"
        style={{ display: "flex", justifyContent: "end" }}
      >
        <Button
          onClick={handleClearFilter}
          style={{
            backgroundColor: "#4f2d7f",
            color: "white",
            padding: "5px 45px",
            fontSize: "10px",
            marginRight: "10px",
            textTransform: "capitalize",
          }}
        >
          Clear Filters
        </Button>
        <Button
          onClick={!isButtonDisabled ? handleFilterApply : null}
          style={{
            backgroundColor: isButtonDisabled ? "grey" : "#4f2d7f",
            cursor: isButtonDisabled ? "not-allowed" : "pointer",
            color: "white",
            padding: "5px 45px",
            fontSize: "10px",
            textTransform: "capitalize",
          }}
        >
          Apply Filters
        </Button>
      </DialogTitle>

      <DialogContent style={{ padding: "0px 8px", marginBottom: "1em" }}>
        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">Supplier GSTIN</div>
            <div className="filter-chips-background-div">
              {supplierGstinFilter.map((gstin, i) => (
                <Chip
                  className="filter-chips"
                  key={gstin}
                  label={gstin}
                  clickable
                  color="primary"
                  onDelete={() => {
                    handleChipDelete(i, "gstin");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%"}}>
              <label for="filled-adornment-amount" className="filter-label">
                Supplier GSTIN
              </label>

              <Autocomplete
                {...defaultPropsSupplierGstins}
                id="auto-complete"
                value={supplierGstin}
                onChange={(event, newValue) => {
                  onChangeSupplierGstin(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button
              onClick={handleAddSupplierGstin}
              className="filter-add-button"
            >
              + Add
            </Button>
          </div>
        </div>

        <div className="filter-chips-background">
          <div style={{ display: "flex" }}>
            <div className="filter-chips-heading">Recipient GSTIN</div>
            <div className="filter-chips-background-div">
              {receipientGstinFilter.map((rgstin, i) => (
                <Chip
                  className="filter-chips"
                  key={rgstin}
                  label={rgstin}
                  clickable
                  color="primary"
                  onDelete={() => {
                    handleChipDelete(i, "rgstin");
                  }}
                />
              ))}
            </div>
          </div>
          <div style={{ display: "flex" }} className="filter-text-input">
            <FormControl fullWidth variant="filled" style={{ width: "40%" }}>
              <label for="filled-adornment-amount" className="filter-label">
                Recipient GSTIN
              </label>

              <Autocomplete
                {...defaultPropsReceipientGstins}
                id="auto-complete"
                value={receipientGstin}
                onChange={(event, newValue) => {
                  onChangeReceipientGstin(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // margin="normal"
                    style={{ backgroundColor: "#eaeaea" }}
                  />
                )}
              />
            </FormControl>
            <Button
              onClick={handleAddReceipientGstin}
              className="filter-add-button"
            >
              + Add
            </Button>
          </div>
        </div>

        <div className="filter-chips-background">
          <div className="filter-chips-heading">Date Range</div>
          <div style={{ display: "flex", marginTop: "1.7em" }}>
            <div style={{ width: "40%" }}>
              <label className="filter-label">Select 'From' Date</label>
              <TextField
                id="date"
                type="date"
                value={selectedFromDate}
                onChange={(e) => {
                  dispatch(setSelectedFromDate(e.target.value));
                }}
                format="DD/MM/YYYY"
                style={{ width: "90%", backgroundColor: "white" }}
              />
            </div>
            <div style={{ width: "40%", marginLeft: "10%" }}>
              <label className="filter-label">Select 'To' Date</label>
              <TextField
                id="date"
                type="date"
                value={selectedToDate}
                onChange={(e) => {
                  dispatch(setSelectedToDate(e.target.value));
                }}
                format="DD/MM/YYYY"
                style={{ width: "90%", backgroundColor: "white" }}
              />
            </div>
          </div>
           {/* <label className="filter-label">Note: The dates mentioned refer to the creation date recorded in the GTaxPro Tool.</label> */}
            <label className="filter-label">Note: This refers to the creation date recorded in GTaxPro</label>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EinvFilter;
